import React, {useEffect, useState} from 'react';
import {VIEW_TYPE} from '../../../../enums/ViewType';
import {useDispatch} from 'react-redux';
import {EMPTY_VALUES, getDateFormat, getDateLong, getFullName, getTimeFormat} from '../../../../Apis/functions';
import {SimpleSearch} from '../../../../reduxToolkit/Search/SearchApi';
import {SEARCH_MODEL} from '../../../../components/table/Model/TableModel';
import {toast} from 'react-toastify';
import {TABLES} from "../../../../Apis/Tables";
import CustomTh from "../../../../components/table/CustomTh";
import CustomTd from "../../../../components/table/CustomTd";
import CustomImageTable from "../../../../components/CustomImageTable";
import {IconAvatarTable} from "../../../../components/buttons/IconButtons";
import {userType} from "../../../../enums/userTypeEnum";
import CustomChip from "../../../../components/CustomChip";
import {colors} from "../../../../enums/colors";
import {MEAL_CATEGORY} from "../../Dining/Manage/Models/Model";
import TableFunction from "../../../../components/table/TableFunction";
import {TABS_KITCHEN} from "../Model/Models";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param model history: model of header section
 * @param state searchElement: Variable for searching the items
 * @param state activeStep: Variable to indicate which tab is active
 * @param state isReload: Variable to indicate if data update is required
 * @param state setIsReload: Variable to update the status
 */
const KitchenHistoryTableApp = ({history, searchElement, activeStep, modified, setModified}) => {
    const dispatch = useDispatch();
    const [results, setResults] = useState({ content: [], totalElements: 0 });
    const [view, setView] = useState(VIEW_TYPE.LIST.name);
    const [tableId, setTableId] = useState("tbl_kh_history_kitchen_tickets"); // Set the table ID for identification
    const [searchId, setSearchId] = useState("txt_kh_search_history_kitchen_tickets"); // Set the search input ID
    const [bodyForExport, setBodyForExport] = useState();
    const option = TABLES.FOODIE_USER_MENU_SELECTION_HISTORY;

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} fixedXY={true} left={50} classes='first_head'>{t("guest")}</CustomTh>,
            <CustomTh tableId={tableId}>{t("user_type")}</CustomTh>,
            <CustomTh tableId={tableId}>{t("meal_time")}</CustomTh>,
            <CustomTh tableId={tableId}>{t("meal_category")}</CustomTh>,
            <CustomTh tableId={tableId}>{t("starter")}</CustomTh>,
            <CustomTh tableId={tableId}>{t("main_course")}</CustomTh>,
            <CustomTh tableId={tableId}>{t("side_dish")}</CustomTh>,
            <CustomTh tableId={tableId}>{t("dessert")}</CustomTh>,
        ];
    };


    const getTbody = () => {
        if (!results || results?.content?.length === 0) return {
            body: [],
            data: []
        };

        const body = results?.content?.map((item) => {
            return (
                <>
                    <CustomTd tableId={tableId} fixed={true} left={0} classes={"first-column"}>
                        <CustomImageTable>
                            <div className="d-flex align-items-center">
                                <div>
                                    <IconAvatarTable
                                        width={32}
                                        height={32}
                                    />
                                </div>
                                <div className={"ml-1"}>
                                    <p className={"mb-1"}>{getFullName(item.userName, item.userLastName, item.userSecondLastName)}</p>
                                    <p className={"mb-1 ibl-ientry-p ibl-font-w-400 font-color-shades-600"}>{`${t("attended")} : ${item?.timedServed ? ((getDateFormat(item?.timedServed, false)) + ' • ' + (getTimeFormat(item?.timedServed))) : EMPTY_VALUES.DEFAULT} `}</p>
                                </div>
                            </div>
                        </CustomImageTable>
                    </CustomTd>
                    <CustomTd
                        tableId={tableId}>{item?.userTypeId ? t(userType[item?.userTypeId]) : EMPTY_VALUES.DEFAULT}</CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomChip
                            background={colors.secondary100}
                            fontColor={colors.secondary700}
                            borderColor={colors.secondary150}
                            legend={item?.mealTimeName || EMPTY_VALUES.DEFAULT}
                            variant='compact'
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomChip
                            background={colors.secondary100}
                            fontColor={colors.secondary700}
                            borderColor={colors.secondary150}
                            legend={MEAL_CATEGORY[item?.isExtraRequest] ? t(MEAL_CATEGORY[item?.isExtraRequest]) : EMPTY_VALUES.DEFAULT}
                            variant='compact'
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId}>{item?.starter?.name || EMPTY_VALUES.DEFAULT}</CustomTd>
                    <CustomTd tableId={tableId}>{item?.main?.name || EMPTY_VALUES.DEFAULT}</CustomTd>
                    <CustomTd tableId={tableId}>{item?.side?.name || EMPTY_VALUES.DEFAULT}</CustomTd>
                    <CustomTd tableId={tableId}>{item?.dessert?.name || EMPTY_VALUES.DEFAULT}</CustomTd>
                </>
            );
        });

        return {
            body,
            data: results?.content
        };
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page, {searchElement}) => {
        if(!history?.date  || !history?.cafeteria?.id){
            return;
        }

        const servingDate = getDateLong(history.date);
        let body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            model: option,
            key: searchElement,
            view
        });
        body =  {
            ...body,
            cafeteriaId: history.cafeteria.id,
            servingDate
        };

        dispatch(SimpleSearch({ body })).then(({ payload: { data: { data, success } } }) => {
                if (success === true) {
                    setResults(data);
                }
            }
        );
    };

    const { t, thead, tbody, pagination, rowsPerPage } = TableFunction({
        data: results,
        view,
        labelRowsPerPage: "request_per_page",
        getTbody,
        getThead,
        fixedPagination: false,
        hasContainer: true,
        searchElement, //New
        getData,//New
        modified,//New
        setModified //New
    });

    /**
     * Function to get history data
     */
    useEffect(() => {
        if(history?.date  && history?.cafeteria?.id) {
            getData(0, {searchElement: ''});
        }else{
            setResults(null);
        }
    }, [history]);

    /**
     * Function to load history when the button is clicked
     */
    useEffect(() => {
        if(modified && activeStep === TABS_KITCHEN.HISTORY.INDEX){
            if(!history?.cafeteria?.id || typeof history?.cafeteria?.id == 'undefined' || !history?.date){
                toast.warn(t("you_must_select_a_diner_and_date"));
                setModified(false);
                return;
            }
            getData(0, {searchElement: ''});
        }
    }, [modified]);


    return {
        t,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        setBodyForExport,
        setResults,
        option,
        rowsPerPage,
        getData
    }

}

export default KitchenHistoryTableApp;
